require('./cookie-policy.scss');
var BaseViews = require('../../../base');
var CookiePolicy = BaseViews.LayoutView.extend({
    template: require('./cookie-policy.html'),
    className: 'fmcy-cookie-policy'
});
module.exports = CookiePolicy;



/** WEBPACK FOOTER **
 ** ./assets/js/common/entry-flow/entry-flow-modal/content/cookie-policy.js
 **/